import React, { useEffect } from 'react';
import Select from 'react-select';
import { useQuery } from '@tanstack/react-query';
import { DROPDOWN_STALE_TIME } from 'utils/constants';
import { Controller } from 'react-hook-form';
import { fetchDepartmentType } from 'services/dropdown';


const DepartmentTypeDropDown = ({ errors, control, rowData, setValue, name, getValues}) => {
    const { data, isLoading, error,  } = useQuery(
        ['department-type-dropdown'],
        () => fetchDepartmentType(),
        {
            keepPreviousData: false,
            staleTime: DROPDOWN_STALE_TIME,
        }
    );
    
    const options = data?.data?.data.map(item => ({
        value: item.id,
        label: item.department_type,
    })) || [];

    useEffect(() => {
        if (rowData && options.length) {
            const selectedOption = options.find(option => option.label === rowData.deptartment_type_name);
            setValue(name, selectedOption);
        }
    }, [rowData, options, setValue]);

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error loading Department Type</div>;

  

    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: 'Department Type is required' }}
            render={({ field }) => (
                <Select
                    {...field}
                    options={options}
                    isClearable
                    placeholder="Select Department Type"
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                    }}
                    className={`react-select-container ${errors[name] ? 'is-invalid' : ''}`}
                />
            )}
        />
    );
};

export default DepartmentTypeDropDown;